import { ccv, crv, cva } from '@/styled-system/css';

export const buttonGroupRecipe = cva({
  base: {
    'display': 'flex',
    'position': 'relative',
    'zIndex': 1,

    '& > :where(a, button)': {
      'position': 'relative',
      'zIndex': 1,
      '&[aria-pressed="true"]': {
        zIndex: 2,
      },
      '&:focus': {
        zIndex: 3,
      },
    },
  },

  variants: {
    conjoined: {
      true: {
        '& > :where(a, button)': {
          '&:not(:first-child):not(:last-child)': {
            borderRadius: 'none',
          },
        },
      },
      false: {},
    },

    ...crv('fluid', {
      true: {
        '& > :where(a, button)': {
          flexBasis: '100%',
          flexGrow: 1,
        },
      },
      false: {
        '& > :where(a, button)': {
          flexBasis: 'auto',
          flexGrow: 0,
        },
      },
    }),

    ...crv('orientation', {
      horizontal: {
        alignItems: 'start',
      },
      vertical: {
        alignItems: 'stretch',
      },
    }),

    ...crv('reverse', {
      true: {},
      false: {},
    }),
  },
  compoundVariants: [
    ...ccv({
      orientation: 'horizontal',
      reverse: true,
      css: {
        flexDirection: 'row-reverse',
      },
    }),

    ...ccv({
      orientation: 'horizontal',
      reverse: false,
      css: {
        flexDirection: 'row',
      },
    }),

    ...ccv({
      orientation: 'vertical',
      reverse: true,
      css: {
        flexDirection: 'column-reverse',
      },
    }),

    ...ccv({
      orientation: 'vertical',
      reverse: false,
      css: {
        flexDirection: 'column',
      },
    }),

    ...ccv({
      conjoined: false,
      orientation: 'horizontal',
      css: {
        gap: 'tighter',
      },
    }),

    ...ccv({
      conjoined: false,
      orientation: 'vertical',
      css: {
        gap: 'ButtonGroup.gap.vert',
      },
    }),

    ...ccv({
      conjoined: true,
      orientation: 'horizontal',
      css: {
        '& > :where(a, button)': {
          '&:not(:first-child)': {
            marginInlineStart: 'conjoined-offsetBorder',
          },
          '&:first-child:not(:only-child)': {
            borderTopRightRadius: 'none',
            borderBottomRightRadius: 'none',
          },
          '&:last-child:not(:only-child)': {
            borderTopLeftRadius: 'none',
            borderBottomLeftRadius: 'none',
          },
        },
      },
    }),

    ...ccv({
      conjoined: true,
      orientation: 'vertical',
      css: {
        '& > :where(a, button)': {
          '&:not(:first-child)': {
            marginBlockStart: 'conjoined-offsetBorder',
          },
          '&:first-child:not(:only-child)': {
            borderBottomLeftRadius: 'none',
            borderBottomRightRadius: 'none',
          },
          '&:last-child:not(:only-child)': {
            borderTopLeftRadius: 'none',
            borderTopRightRadius: 'none',
          },
        },
      },
    }),
  ],
});
